export default "__VITE_ASSET__0_hke2Qi__"